export default __webpack_public_path__ + "static/Plots0044-d1a38b6b038cdb4d924484edd9df8125.jpg";